import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useDispatch } from 'react-redux';

import { setWallCloseStateWrap } from '../../../../../../action';
import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, jTrimModel, wainscotTrimModel } from '../../../../../../utils/Functions';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../CustomMaterial';

const TrimModel = () => {    
    const dispatch = useDispatch();

    const [frontWallCloseSize, setFrontWallCloseSize] = useState(0);
    const [backWallCloseSize, setBackWallCloseSize] = useState(0);
    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);
    const [sideWallLeftPorchSize, setSideWallLeftPorchSize] = useState(0);
    const [sideWallRightPorchSize, setSideWallRightPorchSize] = useState(0);
    const [offSetHeight, setOffSetHeight] = useState(0);
    
    const sideJTrimState = params.p_j_t && params.p_b_c_b_b_l !== "Open" && params.p_b_c_b_b_l !== "Close";
    const frontJTrimState = params.p_j_t_end && params.p_b_c_b_b_f !== "Open" && params.p_b_c_b_b_f !== "Close"  && params.p_b_c_b_b_f !== "Half Dutch End" && params.p_b_c_b_b_f !== "Half End";
    const backJTrimState = params.p_j_t_end && params.p_b_c_b_b_b !== "Open" && params.p_b_c_b_b_b !== "Close"  && params.p_b_c_b_b_b !== "Half Dutch End" && params.p_b_c_b_b_b !== "Half End";
    
    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation === "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption === "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture === "none" || params.wainscotTexture === "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);
    
    const frontWallVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();        

        if (!(params.p_b_c_b_b_f === "Open" || params.p_b_c_b_b_f === "Gable" || params.add_right_back_lean_porch || params.p_b_c_b_b_l === 'Close')) {
            model.moveTo((params.leanB_p_d / 2 + 0.075), frontWallCloseSize);
            model.lineTo((params.leanB_p_d / 2 + 0.075), params.leanB_p_h + offSetHeight);
            model.lineTo((params.leanB_p_d / 2 - 0.08), params.leanB_p_h + offSetHeight);
            model.lineTo((params.leanB_p_d / 2 - 0.08), frontWallCloseSize);
            model.closePath();
        } else if (params.add_right_back_lean_porch && (frontWallCloseSize < sideWallCloseSize)) {
            model.moveTo((params.leanB_p_d / 2 + 0.075), sideWallCloseSize);
            model.lineTo((params.leanB_p_d / 2 + 0.075), frontWallCloseSize);
            model.lineTo((params.leanB_p_d / 2 - 0.08), frontWallCloseSize);
            model.lineTo((params.leanB_p_d / 2 - 0.08), sideWallCloseSize);
            model.closePath();
        }

        return model;
    }, [frontWallCloseSize, sideWallCloseSize, params.p_b_c_b_b_f, params.add_right_back_lean_porch, params.leanB_p_h, params.leanB_p_d, offSetHeight, params.p_b_c_b_b_l])

    const backWallVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_b_b === "Open" || params.p_b_c_b_b_b === "Gable" || params.add_left_back_lean_porch || params.p_b_c_b_b_l === 'Close')) {
            if(params.p_b_c_b_b_l !== 'Close' && params.add_left_back_lean_porch){
                model.moveTo(-(params.leanB_p_d / 2 + 0.075), backWallCloseSize);
                model.lineTo(-(params.leanB_p_d / 2 + 0.075), sideWallCloseSize);
                model.lineTo(-(params.leanB_p_d / 2 - 0.08), sideWallCloseSize);
                model.lineTo(-(params.leanB_p_d / 2 - 0.08), backWallCloseSize);
                model.closePath();
            } else {
                model.moveTo(-(params.leanB_p_d / 2 + 0.075), backWallCloseSize);
                model.lineTo(-(params.leanB_p_d / 2 + 0.075), params.leanB_p_h + offSetHeight);
                model.lineTo(-(params.leanB_p_d / 2 - 0.08), params.leanB_p_h + offSetHeight);
                model.lineTo(-(params.leanB_p_d / 2 - 0.08), backWallCloseSize);
                model.closePath();
            }
        } else if (params.add_left_back_lean_porch && (backWallCloseSize < sideWallCloseSize)) {
            model.moveTo(-(params.leanB_p_d / 2 + 0.075), sideWallCloseSize);
            model.lineTo(-(params.leanB_p_d / 2 + 0.075), backWallCloseSize);
            model.lineTo(-(params.leanB_p_d / 2 - 0.08), backWallCloseSize);
            model.lineTo(-(params.leanB_p_d / 2 - 0.08), sideWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.add_storage_check_back, backWallCloseSize, params.p_b_c_b_b_b, params.add_left_back_lean_porch, params.leanB_p_h, params.leanB_p_d, offSetHeight, params.p_b_c_b_b_l, sideWallCloseSize])

    const dutchDelModelFront = useMemo(() => {
        const freeSpace = 1;
        const trimWidth = 0.2;
        const offset = 0.05 * Math.pow(2, 1 / 2)
        let cornerFreeSpaceW = (params.leanB_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanB_p_h - ((params.b_l_t_r_pB / 12) * params.leanB_p_w) :  params.leanB_p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_back_lean && (params.p_b_c_b_b_f === "Half Dutch End" || params.p_b_c_b_b_f === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.leanB_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_b_f === "Half Dutch End") {
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
                model.lineTo((params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
            } else {
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
            }
            model.lineTo(-(params.leanB_p_w / 2 - freeSpace - trimWidth), 0);
            model.closePath()

            return model;
        } else {
            return []
        }
    }, [params.add_back_lean, params.leanB_p_w, params.leanB_p_h, params.p_b_c_b_b_f])


    const dutchDelModelBack = useMemo(() => {
        const freeSpace = 1;
        const trimWidth = 0.2;
        const offset = 0.05 * Math.pow(2, 1 / 2)
        let cornerFreeSpaceW = (params.leanB_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanB_p_h - ((params.b_l_t_r_pB / 12) * params.leanB_p_w) :  params.leanB_p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_back_lean && (params.p_b_c_b_b_b === "Half Dutch End" || params.p_b_c_b_b_b === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.leanB_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_b_b === "Half Dutch End") {
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
                model.lineTo((params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
            } else {
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanB_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanB_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanB_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
            }
            model.lineTo(-(params.leanB_p_w / 2 - freeSpace - trimWidth), 0);
            model.closePath()

            return model;
        } else {
            return []
        }
    }, [params.add_back_lean, params.leanB_p_w, params.leanB_p_h, params.p_b_c_b_b_b])
    
    const sideWallVrLeftTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_b_l === "Open")) {
            model.moveTo(-(params.leanB_p_d / 2 + sideWallLeftPorchSize + 0.075), sideWallCloseSize);
            model.lineTo(-(params.leanB_p_d / 2 + sideWallLeftPorchSize + 0.075), params.leanB_p_h + offSetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo(-(params.leanB_p_d / 2 + sideWallLeftPorchSize - 0.08), params.leanB_p_h + offSetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo(-(params.leanB_p_d / 2 + sideWallLeftPorchSize - 0.08), sideWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanB_p_h, params.leanB_p_d, offSetHeight, sideWallCloseSize, sideWallLeftPorchSize, params.p_b_c_b_b_l])
    
    const sideWallVrRightTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_b_l === "Open")) {
            model.moveTo((params.leanB_p_d / 2 + sideWallRightPorchSize + 0.073), sideWallCloseSize);
            model.lineTo((params.leanB_p_d / 2 + sideWallRightPorchSize + 0.073), params.leanB_p_h + offSetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo((params.leanB_p_d / 2 + sideWallRightPorchSize - 0.08), params.leanB_p_h + offSetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo((params.leanB_p_d / 2 + sideWallRightPorchSize - 0.08), sideWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanB_p_h, params.leanB_p_d, offSetHeight, sideWallCloseSize, sideWallRightPorchSize, params.p_b_c_b_b_l])

    const jTrimSideModelObj = useMemo(() => {
        let main;
        let wainscot;
        
        const storageVal = params.add_storage_check_back ? Number(params.add_storage_back) : 0

        const storageDelShape = new THREE.Shape();
            storageDelShape.moveTo(-params.leanB_p_d / 2 - 0.02, 0);
            storageDelShape.lineTo(-params.leanB_p_d / 2 - 0.02, params.leanB_p_h);
            storageDelShape.lineTo(-params.leanB_p_d / 2 + parseInt(params.add_storage_back) - 0.04 , params.leanB_p_h)
            storageDelShape.lineTo(-params.leanB_p_d / 2 + parseInt(params.add_storage_back) - 0.04 , 0);
            storageDelShape.closePath();

        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanB_p_d + sideWallLeftPorchSize + sideWallRightPorchSize)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageDelShape, extrudeSettings(1)))

        const meshJTrimCutModel_Temp = meshStorageDelModel.clone();
        meshJTrimCutModel_Temp.position.set(0.1 + params.backLeanStoragePosition, 0, -0.5);
        meshJTrimCutModel_Temp.updateMatrixWorld();

        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.rotation.y = Math.PI / 2
        meshJTrimModel_Temp.position.set(-(params.leanB_p_d / 2 + sideWallLeftPorchSize), sideWallCloseSize + 0.1, 0.0725);
        meshJTrimModel_Temp.updateMatrixWorld()
        
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(-params.leanB_p_pos, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld()
        

        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshJTrimCutModel_CSG = CSG.fromMesh(meshJTrimCutModel_Temp)

        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);

        let JTrimModel_CSG;

        if(params.add_storage_check_back) JTrimModel_CSG = JTrimModel_CSG_Temp.subtract(meshJTrimCutModel_CSG)
        else JTrimModel_CSG = JTrimModel_CSG_Temp

        const CSGJTrimSideModel = CSG.toMesh( JTrimModel_CSG, new THREE.Matrix4())

        main = CSGJTrimSideModel.geometry

        /**********************cutting hole using CSG Front************************/
        const sideWainscotTrimRightPorchSize = (params.add_right_back_lean_porch && params.p_b_c_b_b_l == "Close") ? sideWallRightPorchSize : 0
        const sideWainscotTrimLeftPorchSize = (params.add_left_back_lean_porch && params.p_b_c_b_b_l == "Close") ? sideWallLeftPorchSize : 0
        const storageLength = (params.add_storage_check_back && params.p_b_c_b_b_l != "Close") ? params.leanB_p_d - storageVal : 0
        
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanB_p_d - storageLength + sideWainscotTrimRightPorchSize + sideWainscotTrimLeftPorchSize - 0.01)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2
        meshWainscotTrimModel_Temp.position.set((params.leanB_p_d / -2 - sideWainscotTrimLeftPorchSize + 0.08), 3, 0.07);
        meshWainscotTrimModel_Temp.updateMatrixWorld()
    
        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        
        let wainscotTrimDelModel_CSG;

        if(params.add_storage_check_back) wainscotTrimDelModel_CSG = WainscotTrimModel_CSG.subtract(meshJTrimCutModel_CSG)
        else wainscotTrimDelModel_CSG = WainscotTrimModel_CSG

        const CSGWainscotTrimModel = CSG.toMesh(wainscotTrimDelModel_CSG, new THREE.Matrix4())

        wainscot = CSGWainscotTrimModel.geometry;

        return {main, wainscot}

    }, [params.leanB_p_pos, params.leanB_p_d, params.leanB_p_h, params.backLeanStoragePosition, params.add_storage_back, params.add_storage_check_back, const_var.newDoorsArray, params.add_right_back_lean_porch, params.p_b_c_b_b_l, params.add_left_back_lean_porch, sideWallRightPorchSize, sideWallLeftPorchSize, sideWallCloseSize])

    const jTrimFrontModelObj = useMemo(() => {
        let main;
        let wainscot;

        /**********************cutting hole using CSG Front j-trim************************/
        const meshJTrimFrontModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanB_p_w)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelFrontModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanFront', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))

        const meshJTrimFrontModel_Temp = meshJTrimFrontModel.clone();
        meshJTrimFrontModel_Temp.position.set((params.leanB_p_d / 2 - 0.0075), frontWallCloseSize + (params.p_r_s === 1 && params.p_b_c_b_b_f === 'Gable' ? 0.36 : 0.1), 0.08);
        meshJTrimFrontModel_Temp.updateMatrixWorld()
        
        const meshDelFrontModel_Temp = meshDelFrontModel.clone();
        meshDelFrontModel_Temp.rotateY(Math.PI/2)
        meshDelFrontModel_Temp.position.set(params.leanB_p_d / 2 - 0.5, 0, params.leanB_p_w + (params.p_d/2) + 0.08 + 0.15);
        meshDelFrontModel_Temp.updateMatrixWorld()

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanB_p_pos, 0, -0.7);
        meshSideDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimFrontModel_CSG = CSG.fromMesh(meshJTrimFrontModel_Temp);
        const meshDelFrontModel_CSG = CSG.fromMesh(meshDelFrontModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);

        const JTrimFrontModel_CSG = meshJTrimFrontModel_CSG.subtract(meshDelFrontModel_CSG);
        const JTrimSideDelModel_CSG = JTrimFrontModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGJTrimFrontModel = CSG.toMesh( JTrimSideDelModel_CSG, new THREE.Matrix4())

        main = CSGJTrimFrontModel.geometry

        /**********************cutting hole using CSG for Front Wainscot-trim************************/
        const meshWainscotTrimFrontModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanB_p_w)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimFrontModel_Temp = meshWainscotTrimFrontModel.clone();
        meshWainscotTrimFrontModel_Temp.position.set((params.leanB_p_d / 2), 3 , 0.08);
        meshWainscotTrimFrontModel_Temp.updateMatrixWorld()
    
        const meshWainscotTrimFrontModel_CSG = CSG.fromMesh(meshWainscotTrimFrontModel_Temp);
    
        const wainscotTrimFrontModel_CSG = meshWainscotTrimFrontModel_CSG.subtract(meshDelFrontModel_CSG);
        const SideDelModel_CSG = wainscotTrimFrontModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGWainscotTrimFrontModel = CSG.toMesh(SideDelModel_CSG, new THREE.Matrix4())

        wainscot = CSGWainscotTrimFrontModel.geometry

        return {main, wainscot}

    }, [params.p_d, params.leanB_p_w, params.leanB_p_d, frontWallCloseSize, const_var.newDoorsArray, params.leanB_p_pos, params.p_r_s, params.p_b_c_b_b_f])

    const jTrimBackModelObj = useMemo(() => {
        let main;
        let wainscot;

        const meshJTrimBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanB_p_w)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanBack', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))

        const meshJTrimBackModel_Temp = meshJTrimBackModel.clone();
        meshJTrimBackModel_Temp.rotateY(Math.PI)
        meshJTrimBackModel_Temp.position.set((params.leanB_p_d / -2 + 0.005), backWallCloseSize + (params.p_r_s === 1 && params.p_b_c_b_b_b === 'Gable' ? 0.36 : 0.1), params.leanB_p_w + 0.08);
        meshJTrimBackModel_Temp.updateMatrixWorld()
        
        const meshDelBackModel_Temp = meshDelBackModel.clone();
        meshDelBackModel_Temp.rotateY(Math.PI/2)
        meshDelBackModel_Temp.position.set(-params.leanB_p_d / 2 - 0.5, 0, params.leanB_p_w + (params.p_d/2) + 0.08 + 0.15);
        meshDelBackModel_Temp.updateMatrixWorld()

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanB_p_pos, 0, -0.7);
        meshSideDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimBackModel_CSG = CSG.fromMesh(meshJTrimBackModel_Temp);
        const meshDelBackModel_CSG = CSG.fromMesh(meshDelBackModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);

        const JTrimBackModel_CSG = meshJTrimBackModel_CSG.subtract(meshDelBackModel_CSG);
        const JTrimSideDelModel_CSG = JTrimBackModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGJTrimBackModel = CSG.toMesh( JTrimSideDelModel_CSG, new THREE.Matrix4())

        main = CSGJTrimBackModel.geometry
    
        /**********************cutting hole using CSG Back Wainscot-trim************************/

        const meshWainscotTrimBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanB_p_w + 0.01)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimBackModel_Temp = meshWainscotTrimBackModel.clone();
        meshWainscotTrimBackModel_Temp.rotation.y = Math.PI
        meshWainscotTrimBackModel_Temp.position.set((params.leanB_p_d / -2), 3 ,params.leanB_p_w + 0.07);
        meshWainscotTrimBackModel_Temp.updateMatrixWorld()

        const meshWainscotTrimBackModel_CSG = CSG.fromMesh(meshWainscotTrimBackModel_Temp);

        const wainscotTrimBackModel_CSG = meshWainscotTrimBackModel_CSG.subtract(meshDelBackModel_CSG);
        const SideDelModel_CSG = wainscotTrimBackModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGWainscotTrimBackModel = CSG.toMesh(SideDelModel_CSG, new THREE.Matrix4()) 

        wainscot = CSGWainscotTrimBackModel.geometry

        return {main, wainscot}
    }, [params.p_d, params.leanB_p_w, params.leanB_p_d, backWallCloseSize, const_var.newDoorsArray, params.leanB_p_pos, params.p_r_s, params.p_b_c_b_b_b])

    const storageFrontWall = useMemo(() => {
        const meshStorageFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanB_p_w)))
        const meshFrontStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))

        let meshStorageFrontWainscotModel_Temp = meshStorageFrontWainscotModel.clone();
        meshStorageFrontWainscotModel_Temp.position.set((params.leanB_p_d / -2  + parseInt(params.add_storage_back) + 0.0025), 3 , 0.07)
        meshStorageFrontWainscotModel_Temp.updateMatrixWorld();

        let meshFrontStorageDelModel_Temp = meshFrontStorageDelModel.clone();
        meshFrontStorageDelModel_Temp.position.set((params.leanB_p_d / -2  + parseInt(params.add_storage_back)) - 0.5, 0, ( params.p_d/2 + params.leanB_p_w + 0.23));
        meshFrontStorageDelModel_Temp.rotation.y = Math.PI/2
        meshFrontStorageDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanB_p_pos, 0, -0.7);
        meshSideDelModel_Temp.updateMatrixWorld();

        const meshStorageFrontWainscotModel_CSG = CSG.fromMesh(meshStorageFrontWainscotModel_Temp);
        const meshFrontStorageDelModel_CSG = CSG.fromMesh(meshFrontStorageDelModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);

        const storagefrontWainscotModel_CSG = meshStorageFrontWainscotModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const SideDelModel_CSG = storagefrontWainscotModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGStorageFrontWainscotModel = CSG.toMesh(SideDelModel_CSG,new THREE.Matrix4())
    
        return CSGStorageFrontWainscotModel.geometry
    }, [params.p_d, params.leanB_p_w, params.leanB_p_d, params.add_storage_back, const_var.newDoorsArray, params.leanB_p_pos])

    useMemo(() => {
        if (params.p_r_s === 1) {
            setOffSetHeight(0.04)
        } else {
            if (sideJTrimState === true) {
                setOffSetHeight((params.p_b_c_b_b_l === 'Open') ? 0 : -0.1)
            } else if (sideJTrimState === false) {
                setOffSetHeight(0)
            }
        }
    }, [params.p_r_s, sideJTrimState, params.p_b_c_b_b_l])

    // --- front wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.add_storage_check_back && params.backLeanStoragePosition === params.leanB_p_d - params.add_storage_back) {
            tempWallCloseSize = 0;
        } else {
            if (params.p_b_c_b_b_f === 'Open' || typeof(params.p_b_c_b_b_f) === 'object') {
                if (params.p_r_s === 1) {
                    tempWallCloseSize = params.leanB_p_h + 0.15;
                } else {
                    tempWallCloseSize = params.leanB_p_h;
                }
            } else if (params.p_b_c_b_b_f === "One_Fourth_Close") {
                tempWallCloseSize = params.leanB_p_h / 4 * 3;
            } else if (params.p_b_c_b_b_f === "Gable") {
                tempWallCloseSize = params.leanB_p_h - 0.2;
            } else if (params.p_b_c_b_b_f === "Half_Close") {
                tempWallCloseSize = params.leanB_p_h / 2;
            } else if (params.p_b_c_b_b_f === "Three_Fourth_Close") {
                tempWallCloseSize = params.leanB_p_h / 4;
            } else if (params.p_b_c_b_b_f === "Close") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_b_f === "Half Dutch End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_b_f === "Half End") {
                tempWallCloseSize = 0;
            } else {
                tempWallCloseSize = -1;
            }
        }

        setFrontWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'BLFrontWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_b_f, params.leanB_p_h, params.p_r_s, params.backLeanStoragePosition, params.add_storage_back, params.leanB_p_d])

    // --- back wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.add_storage_check_back && params.backLeanStoragePosition <= 0) {
            tempWallCloseSize = 0;
        } else {
            if (params.p_b_c_b_b_b === 'Open' || typeof(params.p_b_c_b_b_b) === 'object') {
                if (params.p_r_s === 1) {
                    tempWallCloseSize = params.leanB_p_h + 0.15;
                } else {
                    tempWallCloseSize = params.leanB_p_h;
                }
            } else if (params.p_b_c_b_b_b === "One_Fourth_Close") {
                tempWallCloseSize = params.leanB_p_h / 4 * 3;
            } else if (params.p_b_c_b_b_b === "Gable") {
                tempWallCloseSize = params.leanB_p_h - 0.2;
            } else if (params.p_b_c_b_b_b === "Half_Close") {
                tempWallCloseSize = params.leanB_p_h / 2;
            } else if (params.p_b_c_b_b_b === "Three_Fourth_Close") {
                tempWallCloseSize = params.leanB_p_h / 4;
            } else if (params.p_b_c_b_b_b === "Close") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_b_b === "Half Dutch End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_b_b === "Half End") {
                tempWallCloseSize = 0;
            } else {
                tempWallCloseSize = -1;
            }
        }

        setBackWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'BLBackWallCloseState': tempWallCloseSize}))
    }, [params.add_storage_check_back, params.p_b_c_b_b_b, params.leanB_p_h, params.p_r_s, params.backLeanStoragePosition])

    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_b_l === 'Open' || typeof(params.p_b_c_b_b_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanB_p_h + 0.15;
            } else {
                tempWallCloseSize = params.leanB_p_h;
            }
        } else if (params.p_b_c_b_b_l === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_l === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanB_p_h - 3 * params.p_b_c_b_b_l;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_b_l, params.leanB_p_h, params.p_r_s])
    
    // --- porch state
    useMemo(() => {
        if (params.add_left_back_lean_porch) {
            setSideWallLeftPorchSize(params.leanB_p_w);
        } else {
            setSideWallLeftPorchSize(0);
        }
    }, [params.add_left_back_lean_porch, params.leanB_p_w, params.p_r_s])

    useMemo(() => {
        if (params.add_right_back_lean_porch) {
            setSideWallRightPorchSize(params.leanB_p_w);
        } else {
            setSideWallRightPorchSize(0);
        }
    }, [params.add_right_back_lean_porch, params.leanB_p_w, params.p_r_s])

    return (
        <>
        <group position={[0, 0, -(params.p_d / 2 + params.leanB_p_w + 0.02 + 0.21)]}>
            <mesh name="front-wall-trim">
                <extrudeGeometry args={[frontWallVrTrimModel, extrudeSettings(0.225)]} />
                <MaterialTrim visibleSection={"backLean"} />
            </mesh>
            <mesh name="back-wall-trim" position={[0, 0, (params.p_r_s == "1") ? 0 :-0.01]}>
                <extrudeGeometry args={[backWallVrTrimModel, extrudeSettings(0.225)]} />
                <MaterialTrim visibleSection={"backLean"} />
            </mesh>
            <mesh name="side-wall-left-trim">
                <extrudeGeometry args={[sideWallVrLeftTrimModel, extrudeSettings(0.235)]} />
                <MaterialTrim visibleSection={"backLean"} />
            </mesh>
            <mesh name="side-wall-right-trim" position={[0, 0, -0.0025]}>
                <extrudeGeometry args={[sideWallVrRightTrimModel, extrudeSettings(0.225)]} />
                <MaterialTrim visibleSection={"backLean"} />
            </mesh>

            {sideJTrimState && jTrimSideModelObj.main &&
                <mesh name="side-wall-J-trim" geometry={jTrimSideModelObj.main}>
                    <MaterialTrim visibleSection={"backLean"} />
                </mesh>
            }
            {frontJTrimState && jTrimFrontModelObj.main &&
                <mesh name="front-wall-J-trim" geometry={jTrimFrontModelObj.main}>
                    <MaterialTrim visibleSection={"backLean"} />
                </mesh>
            }
            {backJTrimState && jTrimBackModelObj.main &&
                <mesh name="back-wall-J-trim" geometry={jTrimBackModelObj.main}>
                    <MaterialTrim visibleSection={"backLean"} />
                </mesh>
            }
            
            {params.p_w_c_n == true && (params.p_b_c_b_b_l == "Close") && jTrimSideModelObj.wainscot &&
                <mesh name="wainscotTrim" geometry={jTrimSideModelObj.wainscot} >
                    <MaterialWainScotTrimNew   visibleSection={"backlean"}/>
                </mesh>
            }
            {params.p_w_c_n == true && params.p_b_c_b_b_f == "Close" && jTrimFrontModelObj.wainscot &&
                <mesh name="B_L_F_W_wainscotTrim" geometry={jTrimFrontModelObj.wainscot} >
                   <MaterialWainScotTrimNew   visibleSection={"backlean"}/>
                </mesh>
            }
            {params.p_w_c_n == true && params.p_b_c_b_b_b == "Close" && jTrimBackModelObj.wainscot &&
                <mesh name="B_L_B_W_wainscotTrim" geometry={jTrimBackModelObj.wainscot} >
                    <MaterialWainScotTrimNew   visibleSection={"backlean"}/>
                </mesh>
            }
        </group>
        <mesh rotation={[0, Math.PI / 2, 0]} position={[params.leanB_p_d / 2 - 0.1, 0, -params.leanB_p_w / 2 - params.p_d / 2]} >
            <extrudeGeometry args={[dutchDelModelFront, extrudeSettings(0.15)]}/>
            <MaterialTrim visibleSection={"backLean"} />
        </mesh>
        <mesh rotation={[0, Math.PI / 2, 0]} position={[ - (params.leanB_p_d / 2 + 0.1), 0, -params.leanB_p_w / 2 - params.p_d / 2]} >
            <extrudeGeometry args={[dutchDelModelBack, extrudeSettings(0.15)]}/>
            <MaterialTrim visibleSection={"backLean"} />
        </mesh>
        </>
    )
}

export default TrimModel